import { Amenity as BewotecAmenity, Cruise as BewotecCruise, Pricing } from '@/bewotec/openapi'
import { IbePriceModelCode } from '@gecko-akh/pkg-cruise-api-types/src/iris'
import { CLASSIC, CLASSICAI, COMFORTAI, IND, INDAI, LIGHT, PAUSCHAL, PAUSCHALAI } from '../../../../general/master-data.js'
import { IDetailCruiseExtras } from '../../price/interfaces'
import { IAmenity, IAmenityAmount, IExtra, ISurcharge } from '../interfaces.js'

export class DetailCruiseExtras implements IDetailCruiseExtras {
  COMAI: IExtra
  IND: IExtra
  INDAI: IExtra
  CLA: IExtra
  CLAAI: IExtra
  PAU: IExtra
  PAUAI: IExtra
  LIG: IExtra

  constructor(cruise: BewotecCruise) {
    this.COMAI = this.initExtras(cruise, COMFORTAI)
    this.IND = this.initExtras(cruise, IND)
    this.INDAI = this.initExtras(cruise, INDAI)
    this.CLA = this.initExtras(cruise, CLASSIC)
    this.CLAAI = this.initExtras(cruise, CLASSICAI)
    this.PAU = this.initExtras(cruise, PAUSCHAL)
    this.PAUAI = this.initExtras(cruise, PAUSCHALAI)
    this.LIG = this.initExtras(cruise, LIGHT)
  }

  initExtras(cruise: BewotecCruise, priceModel: IbePriceModelCode) {
    const extras: IExtra = {}

    // TODO: remove if mandatory properties are specified
    if (!cruise.cabinCategories?.length || !cruise.priceModel || cruise.priceModel.code !== priceModel) {
      return {}
    }

    for (const category of cruise.cabinCategories) {
      // TODO: remove if mandatory properties are specified
      if (!category.code) {
        return {}
      }

      extras[category.code] = []

      if (
        [COMFORTAI, IND, INDAI].includes(priceModel) &&
        !!category.pricings?.some(pricing => pricing.surcharges?.length)
      ) {
        const surchargeExtra = this.surchargesToExtra(category.pricings)
        extras[category.code]!.push(surchargeExtra)
      }

      if (!!category.amenities?.length) {
        const amenitiesExtras = this.amenitiesToExtras(category.amenities)
        extras[category.code] = extras[category.code]!.concat(amenitiesExtras)
      }
    }

    return extras
  }

  surchargesToExtra(pricings: Pricing[]) {
    let total = 0

    for (const pricing of pricings) {
      if (!!pricing.surcharges?.length) {
        for (const surcharge of pricing.surcharges) {
          total += surcharge.amount ?? 0
        }
      }
    }

    const surcharge: ISurcharge = {
      type: 'discount',
      amount: -total,
      description: pricings[0].surcharges![0].code === 'EB' ? 'FB' : 'FB+',
    }

    return surcharge
  }

  amenitiesToExtras(amenities: BewotecAmenity[]) {
    const result: IAmenity[] = []
    const group: IAmenityAmount = {}

    for (const amenity of amenities) {
      if (!amenity.code) return result

      group[amenity.code] = group[amenity.code] || 0
    }

    for (const id in group) {
      if (!!id) {
        const foundAmenity = amenities.find(amenity => amenity.code === id)

        result.push({
          type: 'gift',
          amount: group[id],
          description: foundAmenity?.description ?? foundAmenity?.name ?? '',
        })
      }
    }
    return result
  }
}
